import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { useDispatch } from 'react-redux';

import { Container } from '~/styles/pagesStyle';

import api from '~/services/api';

import Menu from '~/components/Menu';
import List from './List';
import { addPaginaID } from '~/store/modules/Modulos/actions';
import Footer from '~/components/Footer';

function ModuloPaginaEspec() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [moduloNome, setModuloNome] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    async function getData() {
      dispatch(addPaginaID(id));
      await api.get(`Modulo/${id}`).then((response) => {
        setModuloNome(response.data.nome);
        setLoading(false);
      });
    }
    getData();
  }, [id]);

  return (
    <Container>
      <Footer />
      <Menu />
      {loading ? (
        <Spinner
          style={{ width: '3rem', height: '3rem', margin: '20% 45% 0 0' }}
        />
      ) : (
        <List
          loading={loading}
          moduloNome={moduloNome}
          setLoading={setLoading}
        />
      )}
    </Container>
  );
}

export default ModuloPaginaEspec;
